module.exports = __webpack_public_path__ + "img/icon-order-pickup.8cf78fd9.png";